import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { pushCtaBlockAction } from "./datalayer";
import { Block } from "./library/container";
import { Link } from "./library/link";
const React = require("react");
import { slugify } from "../../custom_utils/helpers";
const renderDescription = (contents, htmlElement, jsxElement)=>{
    return typeof contents == "string" ? /*#__PURE__*/ _createElement(htmlElement.type, {
        ...htmlElement.props,
        key: htmlElement.key,
        dangerouslySetInnerHTML: {
            __html: contents
        }
    }) : /*#__PURE__*/ _jsx(jsxElement.type, {
        ...jsxElement.props,
        children: contents
    }, jsxElement.key);
};
export class CtaBlock extends React.Component {
    render() {
        const p = this.props;
        return /*#__PURE__*/ _jsx(Block, {
            children: /*#__PURE__*/ _jsxs("section", {
                className: `cta cta--block ${p.kind == 'cta_block' ? 'cta--large' : 'cta--small'}`,
                children: [
                    /*#__PURE__*/ _jsx("header", {
                        className: "cta__header",
                        children: /*#__PURE__*/ _jsx("h2", {
                            "data-anchor": slugify(p.title),
                            className: `cta__title ${p.kind == 'cta_block' ? 'title--l' : 'title--ms'}`,
                            children: p.title
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "cta__content",
                        children: renderDescription(p.description, /*#__PURE__*/ _jsx("div", {
                            className: "cta__text"
                        }), /*#__PURE__*/ _jsx("div", {}))
                    }),
                    /*#__PURE__*/ _jsxs("footer", {
                        className: "cta__footer",
                        children: [
                            /*#__PURE__*/ _jsx(Link, {
                                url: p.primaryActionUrl,
                                className: "cta__button button",
                                handle: ()=>pushCtaBlockAction(p.title, "primary", p.primaryActionTitle),
                                children: p.primaryActionTitle
                            }),
                            p.secondaryActionTitle && p.secondaryActionUrl && /*#__PURE__*/ _jsxs(Link, {
                                url: p.secondaryActionUrl,
                                className: "cta__link",
                                handle: ()=>pushCtaBlockAction(p.title, "secondary", p.secondaryActionTitle),
                                children: [
                                    /*#__PURE__*/ _jsx("svg", {
                                        className: "cta__link-icon",
                                        width: "8px",
                                        height: "14px",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ _jsx("use", {
                                            xlinkHref: "#icon--chevron-right"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: p.secondaryActionTitle
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
